'use strict';

angular.module('app.definitions', []).constant('APP', { version: '0.0.1-dev' });


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/app.definitions.js
 ** module id = 8
 ** module chunks = 0
 **/